module.exports = __webpack_public_path__ + "media/assets/img/flags/id-ID-c1bd29515ef87d52d8cedc77783563e2.png";